module.exports = __webpack_public_path__ + "static/media/ai_service.1f9a86f8.svg";